// extracted by mini-css-extract-plugin
module.exports = {"ContainerApollo":"Shell_ContainerApollo__2pCYq","Apollo":"Shell_Apollo__3zdba","SuccessTitle":"Shell_SuccessTitle__3fzg7"};